<div id="dialog" [class]="'relative ' + position" [ngClass]="{ 'px-10': hasPadding, 'full': fullPage }">
  @if (closable) {
    <cds-svg-icon [autofill]="false" name="cross" class="sticky top-6 -mr-4 h-0 flex justify-end" (debounceClick)="close.emit(true)"></cds-svg-icon>
  }
  <ng-content></ng-content>
</div>
